import * as React from 'react';
import { useTheme, Box, IconButton, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FileDownload as FileDownloadIcon } from '@mui/icons-material';
import { useS3Manager } from '../../../../hooks/useS3Manager';
import { StyledSectionHeader } from '../../../../themes/styled-components';

interface ISnapshotsDownloadsCard {
  snapshot?: ISnapshot;
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function SnapshotsBronzeCard (props: ISnapshotsDownloadsCard) {

  const theme = useTheme();
  const { downloadObject, listObjectsAtPrefix } = useS3Manager({ bucketName: process.env.REACT_APP_AWS_S3_DATA_LAKE_BUCKET! });

  const handleDownloadClick = async (dataStage: string, artifactSubPath: string) => {
    console.log(`handleDownloadClick :: ${dataStage} :: ${artifactSubPath}`);
    const prefix = `${process.env.REACT_APP_AWS_S3_DATA_LAKE_ROOT_PATH}/${dataStage}/ama_${props.snapshot?.ClientId}/snapshot=${props.snapshot?.SnapshotDate}/${artifactSubPath}/`;
    const files = await listObjectsAtPrefix(prefix);    
    const key = files.pop()?.BronzePath;
    if (!key) return;
    props.setIsDownloading(true);
    await downloadObject(key);
    props.setIsDownloading(false);
  };

  const tableHeaderStyle = {
    color: theme.palette.text.secondary,
    fontSize: '0.7rem', 
    fontWeight: '900',
    height: '40px',
    padding: 0
  };

  const tableCellStyle = {
    color: theme.palette.text.secondary,
    fontSize: '0.7rem',
    height: '40px',
    padding: 0,
    border: 'none'
  };

  const buttonStyle = {
    backgroundColor: 'white', 
    color: theme.palette.grey[500],
    borderColor: theme.palette.grey[400],    
    '&:hover': { 
      color: theme.palette.grey[500],
      backgroundColor: theme.palette.grey[100],
      borderColor: theme.palette.grey[400],   
    }, 
  };

  const silverDownloadDisabled = props.snapshot?.SilverPath == null || props.snapshot?.SilverPath === '';
  const goldDownloadDisabled = props.snapshot?.GoldPath == null || props.snapshot?.GoldPath === '';

  return (
    <Box sx={{ height: '100%' }}>
      <Paper sx={{ height: '100%', p: 2}}>
        <StyledSectionHeader>Downloads</StyledSectionHeader>
        <TableContainer sx={{ overflow: 'hidden' }}>
          <Table sx={{ width: '100%', border: 'none' }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell colSpan={2} align="left" style={{ width: 'auto', ...tableHeaderStyle }}>Silver</TableCell>  
                <TableCell colSpan={2} align="left" style={{ width: 'auto', ...tableHeaderStyle }}>Gold</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>                  
                <TableCell align="left" style={{...tableCellStyle}}>Snapshot</TableCell>    
                <TableCell align="left" style={{...tableCellStyle, minWidth: '70px'}}>
                  <IconButton 
                    aria-label="Download Silver Snapshot."
                    sx={buttonStyle}
                    disabled={silverDownloadDisabled}
                    onClick={() => handleDownloadClick('silver', 'csv')}>
                    <FileDownloadIcon />
                  </IconButton>    
                </TableCell>  
                <TableCell align="left" style={{...tableCellStyle}}>Snapshot</TableCell>  
                <TableCell align="left" style={{...tableCellStyle}}>
                  <IconButton 
                    aria-label="Download Gold Snapshot."
                    sx={buttonStyle}
                    disabled={goldDownloadDisabled}
                    onClick={() => handleDownloadClick('gold', 'csv')}>
                    <FileDownloadIcon />
                  </IconButton>                    
                </TableCell>  
              </TableRow>
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>                  
                <TableCell align="left" style={{...tableCellStyle}}></TableCell>    
                <TableCell align="left" style={{...tableCellStyle}}></TableCell>  
                <TableCell align="left" style={{...tableCellStyle}}>Stacked</TableCell>  
                <TableCell align="left" style={{...tableCellStyle}}>
                  <IconButton 
                    aria-label="Download Snapshot + Census."
                    sx={buttonStyle}
                    disabled={goldDownloadDisabled}
                    onClick={() => handleDownloadClick('gold', 'stacked')}>
                    <FileDownloadIcon />
                  </IconButton>                    
                </TableCell>  
              </TableRow>
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>                  
                <TableCell align="left" style={{...tableCellStyle}}></TableCell>    
                <TableCell align="left" style={{...tableCellStyle}}></TableCell>  
                <TableCell align="left" style={{...tableCellStyle}}>75 var</TableCell>  
                <TableCell align="left" style={{...tableCellStyle}}>
                  <IconButton 
                    aria-label="Download Snapshot 75 var."
                    sx={buttonStyle}
                    disabled={goldDownloadDisabled}
                    onClick={() => handleDownloadClick('gold', '75_var')}>
                    <FileDownloadIcon />
                  </IconButton>                    
                </TableCell>  
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}